function cartIconBubble(){
    fetch('/')
     .then(response => {
       return response.text();
     })
    .then(responseHTML => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseHTML, 'text/html');
        const newBubble = doc.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');
        if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
        }
    })
    .catch(err => console.error(err));
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  cartIconBubble();
});

function updateVisibleItems() {
    if(document.querySelector('media-gallery slider-component.slider_component_gallery_viewer .product__media-list .product__media-item')){
        const items = [...document.querySelectorAll('media-gallery slider-component.slider_component_gallery_viewer .product__media-list .product__media-item')]
            .filter(li => !li.classList.contains('hidden'));

        document.querySelectorAll('media-gallery slider-component.slider_component_gallery_viewer .product__media-list .product__media-item ').forEach(li => {
            li.classList.remove('third-visible', 'last-visible');
        });
        
        if (items[2]) {
            items[2].classList.add('third-visible');
        }

        const remainingItems = items.length - 3;

        if (remainingItems > 0 && remainingItems % 2 === 1) {
            items[items.length - 1].classList.add('last-visible');
        }
    }
}

function updateVisibleDotItems() {
    if(document.querySelector('slider-component.slider_component_gallery_viewer .slider_dots_main .single_dot_inner')){
        document.querySelectorAll('slider-component.slider_component_gallery_viewer .slider_dots_main .single_dot_inner.hidden button.is-active').forEach(activeButton => {
            activeButton.classList.remove('is-active');
            
            let nextLi = activeButton.closest('.single_dot_inner').nextElementSibling;
            
            while (nextLi && nextLi.classList.contains('hidden')) {
                nextLi = nextLi.nextElementSibling;
            }
            
            const nextButton = nextLi?.querySelector('button');
            if (nextButton) {
                nextButton.classList.add('is-active');
            }
        });
    }
}

function getPreviousSiblings(element) {
    const siblings = [];
    
    let prev = element.closest('.single_dot_inner').previousElementSibling;
    while (prev) {
        siblings.push(prev);
        prev = prev.previousElementSibling;
    }
    const reversed = siblings.toReversed();
    return reversed;
}